const FJColorUtil = {
    hexToRgba: function (hex, opacity) {
        let RGBA =
            'rgba(' +
            parseInt('0x' + hex.slice(1, 3)) +
            ',' +
            parseInt('0x' + hex.slice(3, 5)) +
            ',' +
            parseInt('0x' + hex.slice(5, 7)) +
            ',' +
            opacity / 100 +
            ')';
        return {
            red: parseInt('0x' + hex.slice(1, 3)),
            green: parseInt('0x' + hex.slice(3, 5)),
            blue: parseInt('0x' + hex.slice(5, 7)),
            rgba: RGBA,
        };
    },
    hexToRgb: function (hex) {
        let hexColor = /^#/.test(hex) ? hex.slice(1) : hex,
            r,
            g,
            b;
        hexColor = /^[0-9a-f]{3}|[0-9a-f]{6}$/i.test(hexColor) ? hexColor : 'fffff';
        if (hexColor.length === 3) {
            hexColor = hexColor.replace(/(\w)(\w)(\w)/gi, '$1$1$2$2$3$3');
        }
        r = hexColor.slice(0, 2);
        g = hexColor.slice(2, 4);
        b = hexColor.slice(4, 6);
        r = parseInt(r, 16);
        g = parseInt(g, 16);
        b = parseInt(b, 16);
        return { r, g, b };
    },
    rgbToYuv: function (r, g, b) {
        // 归一化 RGB 值到 [0, 1]
        r /= 255;
        g /= 255;
        b /= 255;

        // 转换
        let y = 0.299 * r + 0.587 * g + 0.114 * b;
        let u = (b - y) * 0.492;
        let v = (r - y) * 0.877;

        return { y: y, u: u, v: v };
    },
    rgb2Lab: function (rgb) {
        let r = rgb.r / 255,
            g = rgb.g / 255,
            b = rgb.b / 255,
            x,
            y,
            z;
        r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
        g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
        b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
        x = (r * 0.4124 + g * 0.3576 + b * 0.1805) / 0.95047;
        y = (r * 0.2126 + g * 0.7152 + b * 0.0722) / 1.0;
        z = (r * 0.0193 + g * 0.1192 + b * 0.9505) / 1.08883;
        x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
        y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
        z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
        return [116 * y - 16, 500 * (x - y), 200 * (y - z)];
    },
    differenceRgb: function (rgb1, rgb2) {
        let labA = FJColorUtil.rgb2Lab(rgb1);
        let labB = FJColorUtil.rgb2Lab(rgb2);
        let deltaL = labA[0] - labB[0];
        let deltaA = labA[1] - labB[1];
        let deltaB = labA[2] - labB[2];
        let c1 = Math.sqrt(labA[1] * labA[1] + labA[2] * labA[2]);
        let c2 = Math.sqrt(labB[1] * labB[1] + labB[2] * labB[2]);
        let deltaC = c1 - c2;
        let deltaH = deltaA * deltaA + deltaB * deltaB - deltaC * deltaC;
        deltaH = deltaH < 0 ? 0 : Math.sqrt(deltaH);
        let sc = 1.0 + 0.045 * c1;
        let sh = 1.0 + 0.015 * c1;
        let deltaLKlsl = deltaL / 1.0;
        let deltaCkcsc = deltaC / sc;
        let deltaHkhsh = deltaH / sh;
        let i = deltaLKlsl * deltaLKlsl + deltaCkcsc * deltaCkcsc + deltaHkhsh * deltaHkhsh;
        return i < 0 ? 0 : Math.sqrt(i);
    },
    /**
     * @description 检查color是否符合规则
     * @param color
     * @returns {boolean}
     */
    isEffectiveColor: function (color) {
        let re1 = /^#([a-f0-9]{3,4}|[a-f0-9]{4}(?:[a-f0-9]{2}){1,2})\b$/i;
        let re2 = /^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/;
        let re3 = /^rgba\((\d{1,3}%?),\s*(\d{1,3}%?),\s*(\d{1,3}%?),\s*(\d*(?:\.\d+)?)\)$/;
        let re4 = /^hsla\((\d+),\s*([\d.]+)%,\s*([\d.]+)%,\s*(\d*(?:\.\d+)?)\)$/;
        let re5 = /^hsl\(\s*(\d+)\s*,\s*(\d*(?:\.\d+)?%)\s*,\s*(\d*(?:\.\d+)?%)\)$/;
        let re6 = /^#([a-f0-9]{8}|[a-f0-9]{4})\b$/;
        let colorList = [
            'LightPink',
            'Pink',
            'Crimson',
            'LavenderBlush',
            'PaleVioletRed',
            'HotPink',
            'DeepPink',
            'MediumVioletRed',
            'Orchid',
            'Thistle',
            'plum',
            'Violet',
            'Magenta',
            'Fuchsia',
            'DarkMagenta',
            'Purple',
            'MediumOrchid',
            'DarkVoilet',
            'DarkOrchid',
            'Indigo',
            'BlueViolet',
            'MediumPurple',
            'MediumSlateBlue',
            'SlateBlue',
            'DarkSlateBlue',
            'Lavender',
            'GhostWhite',
            'Blue',
            'MediumBlue',
            'MidnightBlue',
            'DarkBlue',
            'Navy',
            'RoyalBlue',
            'CornflowerBlue',
            'LightSteelBlue',
            'LightSlateGray',
            'SlateGray',
            'DoderBlue',
            'AliceBlue',
            'SteelBlue',
            'LightSkyBlue',
            'SkyBlue',
            'DeepSkyBlue',
            'LightBLue',
            'PowDerBlue',
            'CadetBlue',
            'Azure',
            'LightCyan',
            'PaleTurquoise',
            'Cyan',
            'Aqua',
            'DarkTurquoise',
            'DarkSlateGray',
            'DarkCyan',
            'Teal',
            'MediumTurquoise',
            'LightSeaGreen',
            'Turquoise',
            'Auqamarin',
            'MediumAquamarine',
            'MediumSpringGreen',
            'MintCream',
            'SpringGreen',
            'SeaGreen',
            'Honeydew',
            'LightGreen',
            'PaleGreen',
            'DarkSeaGreen',
            'LimeGreen',
            'Lime',
            'ForestGreen',
            'Green',
            'DarkGreen',
            'Chartreuse',
            'LawnGreen',
            'GreenYellow',
            'OliveDrab',
            'Beige',
            'LightGoldenrodYellow',
            'Ivory',
            'LightYellow',
            'Yellow',
            'Olive',
            'DarkKhaki',
            'LemonChiffon',
            'PaleGodenrod',
            'Khaki',
            'Gold',
            'Cornislk',
            'GoldEnrod',
            'FloralWhite',
            'OldLace',
            'Wheat',
            'Moccasin',
            'Orange',
            'PapayaWhip',
            'BlanchedAlmond',
            'NavajoWhite',
            'AntiqueWhite',
            'Tan',
            'BrulyWood',
            'Bisque',
            'DarkOrange',
            'Linen',
            'Peru',
            'PeachPuff',
            'SandyBrown',
            'Chocolate',
            'SaddleBrown',
            'SeaShell',
            'Sienna',
            'LightSalmon',
            'Coral',
            'OrangeRed',
            'DarkSalmon',
            'Tomato',
            'MistyRose',
            'Salmon',
            'Snow',
            'LightCoral',
            'RosyBrown',
            'IndianRed',
            'Red',
            'Brown',
            'FireBrick',
            'DarkRed',
            'Maroon',
            'White',
            'WhiteSmoke',
            'Gainsboro',
            'LightGrey',
            'Silver',
            'DarkGray',
            'Gray',
            'DimGray',
            'Black',
        ];
        let isColor = colorList.findIndex(c => {
            return c.toLocaleUpperCase() === color.toLocaleUpperCase();
        });
        return (
            re2.test(color) ||
            re1.test(color) ||
            re3.test(color) ||
            re4.test(color) ||
            re5.test(color) ||
            re6.test(color) ||
            isColor !== -1
        );
    },

    hsvToRgb: function (h, s, v) {
        // 将 h 归一化到 [0, 360)
        h = h % 360;
        if (h < 0) h += 360;

        // 将 s 和 v 归一化到 [0, 1]
        s = s / 100;
        v = v / 100;

        const c = v * s;
        const x = c * (1 - Math.abs(((h / 60) % 2) - 1));
        const m = v - c;

        let r, g, b;
        if (h < 60) {
            [r, g, b] = [c, x, 0];
        } else if (h < 120) {
            [r, g, b] = [x, c, 0];
        } else if (h < 180) {
            [r, g, b] = [0, c, x];
        } else if (h < 240) {
            [r, g, b] = [0, x, c];
        } else if (h < 300) {
            [r, g, b] = [x, 0, c];
        } else {
            [r, g, b] = [c, 0, x];
        }

        return {
            r: Math.round((r + m) * 255),
            g: Math.round((g + m) * 255),
            b: Math.round((b + m) * 255),
        };
    },

    rgbToHsv: function (r, g, b) {
        // 将 RGB 值归一化到 [0, 1]
        r = r / 255;
        g = g / 255;
        b = b / 255;

        const max = Math.max(r, g, b);
        const min = Math.min(r, g, b);
        const delta = max - min;

        let h = 0;
        const s = max === 0 ? 0 : delta / max;
        const v = max;

        if (delta !== 0) {
            if (max === r) {
                h = ((g - b) / delta) % 6;
            } else if (max === g) {
                h = (b - r) / delta + 2;
            } else {
                h = (r - g) / delta + 4;
            }

            h = h * 60;
            if (h < 0) h += 360;
        }

        return {
            h: Math.round(h),
            s: Math.round(s * 100),
            v: Math.round(v * 100),
        };
    },

    hsvToHex: function (h, s, v) {
        const { r, g, b } = this.hsvToRgb(h, s, v);
        return this.RgbToHex(r, g, b);
    },

    hexToHsv: function (hex) {
        // 检查颜色格式是否有效
        if (!this.isEffectiveColor(hex)) {
            return { h: 0, s: 0, v: 100 }; // 返回白色
        }

        // 处理 rgb 格式
        if (hex.startsWith('rgb')) {
            const matches = hex.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
            if (matches) {
                const [, r, g, b] = matches.map(Number);
                return this.rgbToHsv(r, g, b);
            }
            return { h: 0, s: 0, v: 100 }; // 返回白色
        }

        // 处理 hex 格式
        const [r, g, b] = this.HexToRgb(hex);
        if (r === null || g === null || b === null) {
            return { h: 0, s: 0, v: 100 }; // 返回白色
        }
        return this.rgbToHsv(r, g, b);
    },

    //hex颜色转rgb颜色
    HexToRgb: function (str) {
        const r = /^\#?[0-9A-Fa-f]{6}$/;
        // 检查字符串是否是有效的六位十六进制颜色值
        if (!r.test(str)) {
            return null;
        }
        // 去掉前面的 # 符号（如果有）
        str = str.replace('#', '');
        // 将字符串分成三个两位的部分
        const hxs = str.match(/../g);
        // 将十六进制部分转换成十进制数
        for (let i = 0; i < 3; i++) hxs[i] = parseInt(hxs[i], 16);
        // 返回结果数组
        return hxs;
    },

    //GRB颜色转Hex颜色
    RgbToHex: function (a, b, c) {
        const r = /^\d{1,3}$/;
        if (!r.test(a) || !r.test(b) || !r.test(c)) {
            return null;
        }
        const hexs = [a.toString(16), b.toString(16), c.toString(16)];
        for (let i = 0; i < 3; i++) if (hexs[i].length === 1) hexs[i] = '0' + hexs[i];
        return '#' + hexs.join('');
    },

    //得到hex颜色值为color的加深颜色值，level为加深的程度，限0-1之间
    getDarkColor: function (color, level) {
        const r = /^\#?[0-9A-F]{6}$/;
        if (!r.test(color)) return window.alert('输入错误的hex颜色值');
        const rgbc = this.HexToRgb(color);
        //floor 向下取整
        for (let i = 0; i < 3; i++) rgbc[i] = Math.floor(rgbc[i] * (1 - level));
        return this.RgbToHex(rgbc[0], rgbc[1], rgbc[2]);
    },

    /**
     * @desc 获取颜色的亮色
     * @param color
     * @param level
     * @returns {*|void|string}
     */
    getLightColor: function (color, level) {
        const r = /^\#?[0-9A-Fa-f]{6}$/;
        // 检查字符串是否是有效的六位十六进制颜色值
        if (!r.test(color)) {
            return null;
        }
        const rgbc = this.HexToRgb(color);
        for (let i = 0; i < 3; i++) rgbc[i] = Math.floor((255 - rgbc[i]) * level + rgbc[i]);
        return this.RgbToHex(rgbc[0], rgbc[1], rgbc[2]);
    },

    // 获取根据基础颜色衍生的后续颜色
    getDeriveColorsFromBaseColors: function (baseColors, totalColors) {
        const __interpolateColor = (color1, color2, factor) => {
            let result = color1.slice();
            for (let i = 0; i < 3; i++) {
                result[i] = Math.round(result[i] + factor * (color2[i] - color1[i]));
            }
            return result;
        };

        const colors = [...baseColors];
        const numBaseColors = baseColors.length;

        // Calculate how many colors we need to generate after the base colors
        const remainingColors = totalColors - numBaseColors;

        // Calculate the number of colors to generate between each pair of base colors
        const colorsPerSegment = Math.floor(remainingColors / (numBaseColors - 1));
        const extraColors = remainingColors % (numBaseColors - 1);

        for (let i = 0; i < numBaseColors - 1; i++) {
            const color1 = FJColorUtil.HexToRgb(baseColors[i]);
            const color2 = FJColorUtil.HexToRgb(baseColors[i + 1]);
            const segmentLength = colorsPerSegment + (i < extraColors ? 1 : 0);

            for (let j = 1; j <= segmentLength; j++) {
                const factor = j / (segmentLength + 1);
                const interpolatedColor = __interpolateColor(color1, color2, factor);
                colors.push(FJColorUtil.RgbToHex(interpolatedColor[0], interpolatedColor[1], interpolatedColor[2]));
            }
        }

        return colors.slice(0, totalColors);
    },
};

export default FJColorUtil;
